import { createContext, useCallback, useMemo, useState, type PropsWithChildren } from "react";

import { useNonNullableContext } from "app/common";

type AllCompetitorsModalContextType = {
    isOpen: boolean;
    openModal: () => void;
    closeModal: () => void;
};

const AllCompetitorsModalContext = createContext<AllCompetitorsModalContextType | undefined>(undefined);

export const useAllCompetitorsModal = () => useNonNullableContext(AllCompetitorsModalContext);

export const AllCompetitorsModalProvider = ({ children }: PropsWithChildren) => {
    const [isOpen, setIsOpen] = useState(false);

    const handleOpen = useCallback(() => {
        setIsOpen(true);
    }, []);

    const handleClose = useCallback(() => {
        setIsOpen(false);
    }, []);

    const value = useMemo(
        () => ({
            isOpen,
            openModal: handleOpen,
            closeModal: handleClose,
        }),
        [isOpen, handleOpen, handleClose],
    );

    return <AllCompetitorsModalContext value={value}>{children}</AllCompetitorsModalContext>;
};
